"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlaygroundStencil = exports.playgroundStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.playgroundStencilDefinition = {
    view: {
        label: 'Playground',
        category: 'tag',
        titleItems: ['title'],
        imageItems: [],
        contentAreas: [
            {
                name: 'main',
                items: ['title'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'type-of-playground',
                            'preferred-label',
                            'alternative-labels',
                            'tag-status',
                            'uri-title',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: ['broader-playground'],
            },
        ],
    },
    content: {
        [properties_1.alternativeLabelsPropertyDefinition.name]: properties_1.alternativeLabelsPropertyDefinition,
        [properties_1.broaderPlaygroundPropertyDefinition.name]: properties_1.broaderPlaygroundPropertyDefinition,
        [properties_1.preferredLabelPropertyDefinition.name]: properties_1.preferredLabelPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.tagStatusPropertyDefinition.name]: properties_1.tagStatusPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.typeOfPlaygroundPropertyDefinition.name]: properties_1.typeOfPlaygroundPropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
    },
    roles: ['admin', 'taxonomy-manager'],
    spaces: ['global'],
    localizations: ['en'],
    name: 'playground',
};
const isPlaygroundStencil = (stencil) => {
    return stencil.name === exports.playgroundStencilDefinition.name;
};
exports.isPlaygroundStencil = isPlaygroundStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxheWdyb3VuZC5zdGVuY2lsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0ZW5jaWxzL3BsYXlncm91bmQuc3RlbmNpbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSw4Q0FVc0I7QUFFVCxRQUFBLDJCQUEyQixHQUFHO0lBQ3pDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxZQUFZO1FBQ25CLFFBQVEsRUFBRSxLQUFLO1FBQ2YsVUFBVSxFQUFFLENBQUMsT0FBTyxDQUFDO1FBQ3JCLFVBQVUsRUFBRSxFQUFFO1FBQ2QsWUFBWSxFQUFFO1lBQ1o7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osS0FBSyxFQUFFLENBQUMsT0FBTyxDQUFDO2FBQ2pCO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osUUFBUSxFQUFFO29CQUNSO3dCQUNFLElBQUksRUFBRSxTQUFTO3dCQUNmLEtBQUssRUFBRTs0QkFDTCxvQkFBb0I7NEJBQ3BCLGlCQUFpQjs0QkFDakIsb0JBQW9COzRCQUNwQixZQUFZOzRCQUNaLFdBQVc7eUJBQ1o7cUJBQ0Y7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLFVBQVU7d0JBQ2hCLEtBQUssRUFBRSxDQUFDLFlBQVksQ0FBQztxQkFDdEI7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLG1CQUFtQjt3QkFDekIsS0FBSyxFQUFFLENBQUMsc0JBQXNCLENBQUM7cUJBQ2hDO2lCQUNGO2FBQ0Y7WUFDRDtnQkFDRSxJQUFJLEVBQUUsU0FBUztnQkFDZixLQUFLLEVBQUUsQ0FBQyxvQkFBb0IsQ0FBQzthQUM5QjtTQUNGO0tBQ0Y7SUFDRCxPQUFPLEVBQUU7UUFDUCxDQUFDLGdEQUFtQyxDQUFDLElBQUksQ0FBQyxFQUFFLGdEQUFtQztRQUMvRSxDQUFDLGdEQUFtQyxDQUFDLElBQUksQ0FBQyxFQUFFLGdEQUFtQztRQUMvRSxDQUFDLDZDQUFnQyxDQUFDLElBQUksQ0FBQyxFQUFFLDZDQUFnQztRQUN6RSxDQUFDLGtEQUFxQyxDQUFDLElBQUksQ0FBQyxFQUFFLGtEQUFxQztRQUNuRixDQUFDLHlDQUE0QixDQUFDLElBQUksQ0FBQyxFQUFFLHlDQUE0QjtRQUNqRSxDQUFDLHdDQUEyQixDQUFDLElBQUksQ0FBQyxFQUFFLHdDQUEyQjtRQUMvRCxDQUFDLG9DQUF1QixDQUFDLElBQUksQ0FBQyxFQUFFLG9DQUF1QjtRQUN2RCxDQUFDLCtDQUFrQyxDQUFDLElBQUksQ0FBQyxFQUFFLCtDQUFrQztRQUM3RSxDQUFDLHVDQUEwQixDQUFDLElBQUksQ0FBQyxFQUFFLHVDQUEwQjtLQUM5RDtJQUNELEtBQUssRUFBRSxDQUFDLE9BQU8sRUFBRSxrQkFBa0IsQ0FBQztJQUNwQyxNQUFNLEVBQUUsQ0FBQyxRQUFRLENBQUM7SUFDbEIsYUFBYSxFQUFFLENBQUMsSUFBSSxDQUFDO0lBQ3JCLElBQUksRUFBRSxZQUFZO0NBQ1ksQ0FBQTtBQUl6QixNQUFNLG1CQUFtQixHQUFHLENBQUMsT0FBb0IsRUFBZ0MsRUFBRTtJQUN4RixPQUFPLE9BQU8sQ0FBQyxJQUFJLEtBQUssbUNBQTJCLENBQUMsSUFBSSxDQUFBO0FBQzFELENBQUMsQ0FBQTtBQUZZLFFBQUEsbUJBQW1CLHVCQUUvQiJ9